<style>
    @page {
        size: a4 portrait;
        margin: 20px 20px 20px 20px;
    }
</style>

<table>
    <tr>
        <td>
    <div class="disclaimer_download_page" #download style="max-width: 100%; margin: 0 auto;" >
        <div class="disclaimer-popup">
            <div class="sucess-section disclaimer_download_content">
                <div class="dis_dwnld_top_blk d-flex justify-content-center">
                    <img src="assets/images/AL_FALSON_LOGO.svg" alt="left-arrow" class="dis_company_img mb_15">
                </div>
                <h1 class="font_24 fw-bold Aed-add-text mb_20">
                    {{ "Registration/Disclaimer" | translate }}
                </h1>
                <div class="dis_content_info_blk">
                    <div class="d-flex align-items-start justify-content-between mb_20">
                        <img *ngIf="registrationData?.PhotoBase64Format" [src]="registrationData?.PhotoBase64Format"
                            alt="Customer photo" class="w-50px">

                        <h5 *ngIf="registrationData.CreatedOn" class="font_16 fw-semi text_black m-0">Registered at:
                            <span class="fw-normal"> {{registrationData.CreatedOn}}</span>
                        </h5>
                    </div>
                    <div class="d-flex align-items-start justify-content-between mb_20">
                        <div>
                            <h6 class="font_18 fw-semi text_black m-0">Emirates ID Details</h6>
                            <h5 *ngIf="registrationData.EmiratesID" class="font_16 fw-semi text_black m-0">Card number:
                                <span class="fw-normal"> {{registrationData.EmiratesID}}</span>
                            </h5>
                            <h5 *ngIf="registrationData.EmiratesIDExpiryDate" class="font_16 fw-semi text_black m-0">
                                Card ExpiryDatet: <span class="fw-normal">
                                    {{registrationData.EmiratesIDExpiryDate}}</span></h5>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="mr_10" *ngIf="registrationData.EidFront">
                                <div><img [src]="registrationData.EidFront" alt="eidFrontphoto" class="w-50px"
                                        (mouseenter)="ViewImage(viewImage,registrationData.EidFront)"></div>
                            </div>
                            <div *ngIf="registrationData.Eidback">
                                <div><img [src]="registrationData.Eidback" alt="eidBackphoto" class="w-50px"
                                        (mouseenter)="ViewImage(viewImage,registrationData.Eidback)"></div>
                            </div>
                        </div>
                    </div>
                    <div class="dis_dwnld_customer_blk">
                        <h5 class="font_18 fw-semi dis_customer_info_heading m-0">Personal Information</h5>
                        <div *ngIf="registrationData.Firstname"
                            class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                            <span class="font_16 fw-normal text_black">Full Name</span>
                            <span class="font_16 fw-normal text_black"> {{registrationData.Firstname}} {{registrationData.Lastname}}</span>
                        </div>
                        <div *ngIf="registrationData.FirstnameArabic"
                            class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                            <span class="font_16 fw-normal text_black">Full Name Arabic</span>
                            <span class="font_16 fw-normal text_black"> {{registrationData.FirstnameArabic}}
                                {{registrationData.LastnameArabic}}</span>
                        </div>
                        <div *ngIf="registrationData.DateOfBirth"
                            class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                            <span class="font_16 fw-normal text_black">Date of Birth</span>
                            <span class="font_16 fw-normal text_black"> {{registrationData.DateOfBirth}}</span>
                        </div>
                        <div *ngIf="registrationData.Nationality"
                            class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                            <span class="font_16 fw-normal text_black">Nationality</span>
                            <span class="font_16 fw-normal text_black"> {{registrationData.Nationality}}</span>
                        </div>
                        <div *ngIf="registrationData.Street"
                            class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                            <span class="font_16 fw-normal text_black">Address</span>
                            <span class="font_16 fw-normal text_black">{{registrationData.Street}},
                                {{registrationData.City}} - {{registrationData.PostalCode}}</span>
                        </div>
                        <div *ngIf="registrationData.MobileNumber"
                            class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                            <span class="font_16 fw-normal text_black">Mobile Number</span>
                            <span class="font_16 fw-normal text_black"> {{registrationData.MobileNumber}}</span>
                        </div>
                        <div *ngIf="registrationData.EmailId"
                            class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                            <span class="font_16 fw-normal text_black">Email address</span>
                            <span class="font_16 fw-normal text_black"> {{registrationData.EmailId}}</span>
                        </div>
                        <div *ngIf="registrationData.Gender"
                            class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                            <span class="font_16 fw-normal text_black">Gender</span>
                            <span class="font_16 fw-normal text_black"> {{registrationData.Gender}}</span>
                        </div>
                        <h5 *ngIf="registrationData.AccountName" class="font_20 fw-semi dis_customer_info_heading m-0">Professional details</h5>
                        <div *ngIf="registrationData.AccountName"
                            class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                            <span class="font_16 fw-normal text_black">Company Name</span>
                            <span class="font_16 fw-normal text_black"> {{registrationData.AccountName}}</span>
                        </div>
                        <div *ngIf="registrationData.discOf === 'EVENTS'">
                            <h5 class="font_20 fw-semi dis_customer_info_heading m-0">
                                Selected Event</h5>
                            <div *ngIf="registrationData.EventName"
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">Event Name</span>
                                <span class="font_16 fw-normal text_black"> {{registrationData.EventName}}</span>
                            </div>
                            <div
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">Activity Registration ID</span>
                                <span class="font_16 fw-normal text_black">
                                    {{registrationData.ActivityRegistrationId}}</span>
                            </div>
                            <div *ngIf="registrationData.CategoryName"
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">Category Name</span>
                                <span class="font_16 fw-normal text_black"> {{registrationData.CategoryName}}</span>
                            </div>
                            <div
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">Activity Name</span>
                                <span class="font_16 fw-normal text_black"> {{registrationData.ActivityName}}</span>
                            </div>
                            <div
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">Start Date</span>
                                <span class="font_16 fw-normal text_black"> {{registrationData.StartDate}}</span>
                            </div>
                            <div
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">End Date</span>
                                <span class="font_16 fw-normal text_black"> {{registrationData.EndDate}}</span>
                            </div>
                            <div
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">No. of Players</span>
                                <span class="font_16 fw-normal text_black"> {{registrationData.NoOfPlayers}}</span>
                            </div>
                        </div>
                        <div *ngIf="registrationData.discOf  !== 'EVENTS'">
                            <h5 *ngIf="registrationData.discOf === 'ACTIVITY'"
                                class="font_20 fw-semi dis_customer_info_heading m-0">
                                Selected Activity</h5>
                            <h5 *ngIf="registrationData.discOf === 'MEMBERSHIP'"
                                class="font_20 fw-semi dis_customer_info_heading m-0">
                                Selected Membership</h5>
                            <div
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span *ngIf="registrationData.discOf === 'ACTIVITY'" class="font_16 fw-normal text_black">Activity Registration ID</span>
                                <span *ngIf="registrationData.discOf === 'MEMBERSHIP'" class="font_16 fw-normal text_black">Membership Registration ID</span>
                                <span class="font_16 fw-normal text_black">
                                    {{registrationData.ActivityRegistrationId}}</span>
                            </div>
                            <div *ngIf="registrationData.CategoryName"
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">Category Name</span>
                                <span class="font_16 fw-normal text_black"> {{registrationData.CategoryName}}</span>
                            </div>
                            <div
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">Activity Name</span>
                                <span class="font_16 fw-normal text_black"> {{registrationData.ActivityName}}</span>
                            </div>
                            <div
                                class="d-flex align-items-center justify-content-between dis_customer_contents border_bottom_lightblack">
                                <span class="font_16 fw-normal text_black">Status</span>
                                <span class="font_16 fw-normal text_black"> {{registrationData.status}}</span>
                            </div>
                        </div>
                    </div>
                    <table>
                        <tr>
                            <td class="">
                                    <div class="disclaimer_rules_blk d-flex ">
                                        <div class="eng_disclaimer w-50 pr_20 ">
                                            <div class="age-paragraph">
                                                <h2 class="font_16 fw-bold Aed-add-text mb_17">
                                                    {{ "Disclaimer" | translate }}
                                                </h2>
                                                <p class="font_14 fw-med Aed-add-text mb_0">
                                                    {{ common.disclaimerHead | translate }}<br />
                                                </p>
                                            </div>
            
                                            <div class="age-paragraph">
                                              <ol class="font_14 pl_20">
                                                <li>{{ common.disclaimerOne | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerTwo | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerThree | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerFour | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerFive | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerSix | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerSeven | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerEight | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerNine | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerTen | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimerEleven | translate }}</li>
                                                <br />
                                                <li>{{ common.disclaimertwelve | translate }}</li>
                                                <br />
                                                <li>{{common.disclaimerThirteen}}</li>
                                                <br />
                                              </ol>
            
                                                <p class="font_14 fw-med Aed-add-text mb_40">
                                                    {{ common.disclaimerHeadTwo | translate }}
                                                </p>
            
                                                <!--<p class="font_14 fw-med Aed-add-text mb_40">
                                                    {{ common.disclaimerSwimming | translate }}
                                                </p>-->
                                            </div>
                                        </div>
            
                                        <div class="eng_disclaimer w-50 pl_20">
                                          <div class="age-paragraph">
                                            <h2 class="font_16 fw-bold Aed-add-text mb_17">
                                              تنصل
                                            </h2>
                                            <p class="font_14 fw-med Aed-add-text mb_0">
                                              مقابل السماح لي بممارسة أي نشاط أو أنشطة يقدمها منتجع الفرسان الرياضي الدولي ذ.م.م (ويشار إليه لاحقاً بمنتجع "الفرسان") (بما في ذلك، على سبيل المثال لا الحصر،  رياضة الرماية، ركوب الخيل، الرياضات المائية، واستخدام السلاح ورياضة السيارات (ويشار إلى كل منها بلفظ "النشاط" وإليها مجتمعة بلفظ "الأنشطة)، فإنني أقر وأؤكد وأوافق على ما يلي:<br />
                                            </p>
                                          </div>
                                          <div class="age-paragraph">
                                            <ol class="font_14 pl_20">
                                              <li>
                                                أقر بوجود مخاطرة كبيرةأقر بوجود مخاطرة كبيرة بالإصابة بسبب الأنشطة أو الأسلحة أو المعدات المستخدمة في الأنشطة، وبأن ذلك يحتوي على خطورة كبيرة بما في ذلك خطر الإعاقة أو الموت. إذا تم اتباع التعليمات الخاصة باستخدام المعدات والمشاركة في الأنشطة، يمكن عندئذ القيام بالأنشطة والاستمتاع بها بأمان. لذلك، أقر بأنه في حين أن المنظمين قد قاموا باتخاذ كل الاحتياطات وأن استخدام معدات الحماية سيقلل من هذه المخاطر، فإن خطر الإصابة الجسيمة أو الوفاة لا يزال موجوداً.
                                              </li>
                                              <br />
                                              <li>
                                                بكامل حريتي وعلمي بعواقب ذلك، فإنني أتحمل المسؤولية عن جميع هذه المخاطر من كافة وأي من الأنشطة، المعروفة وغير المعروفة على حد سواء، كما أتحمل المسؤولية عن مشاركتي باستثناء أي خسارة أو مسؤولية أو ضرر أو تكلفة ناجمة عن الإهمال أو الإهمال الجسيم أو سوء السلوك المتعمد من جانب الأشخاص الذين يتم إعفاؤهم من المسؤولية أدناه والذين يتم تحديدهم بأنه تم إعفاؤهم من المسؤولية.
                                              </li>
                                              <br />
                                              <li>
                                                أدرك بأن جميع الأنشطة يمكن أن تكون بحاجة لبذل الجهود الجسدية والعقلية. كما أقر وأؤكد بموجبه بأنني لائق بدنياً ولا أعاني من أي حالة طبية قد تؤثر على قدرتي على المشاركة في النشاط أو الأنشطة بأمان.
                                              </li>
                                              <br />
                                              <li>
                                                أؤكد وأقر أنني تلقيت كامل التدريب والتوجيه المناسبين. كما أؤكد أنني قد قرأت القواعد وسألتزم بها في جميع الأوقات. أدرك تماماً قواعد الأنشطة المختارة وسأمتثل لجميع القواعد واللوائح. إذا لاحظتُ أي مخاطر غير عادية أو غير ضرورية أثناء مشاركتي، فإنني سألفت انتباه أقرب مسؤول إلى هذا الأمر في أقرب وقت ممكن عملياً.
                                              </li>
                                              <br />
                                              <li>
                                                أفهم أنه في حالة حدوث طارئ طبي يتطلب إزالة الملابس من أجل تقديم العلاج الطبي، بما في ذلك على سبيل المثال لا الحصر الإنعاش القلبي الرئوي (CPR)، أو استخدام جهاز إزالة الرجفان، أو الإسعافات الأولية، قد يحتاج موظفو المنتجع إلى إزالة الملابس لضمان سلامة طفلي. وبناءً على ذلك، فإنني أتنازل عن أي دعاوى أو مسؤوليات تتعلق بذلك أثناء تقديم هذا العلاج الطبي.
                                              </li>
                                              <br />
                                              <li>
                                                أبرئ، بالأصالة عن نفسي وبالنيابة عن ورثتي وممثليّ الشخصيين وأقاربي، وأخلي مسؤولية منتجع الفرسان في جميع الأوقات، وأوافق على عدم مقاضاتهم هم أو أي من الشركات المرتبطة بها أو أي من موظفيهم أو مسؤوليهم أو وكلائهم أو شركات تأمينهم أو موردي معداتهم عن أي مسؤولية عن أي إصابة جسدية أو إعاقة أو وفاة قد تحدث لي أثناء ممارسة الأنشطة باستثناء عندما تكون تلك الإصابة أو الإعاقة أو الوفاة أو أي أضرار أخرى غير مذكورة هنا ناتجة عن الإهمال أو الإهمال الكلي أو سوء السلوك المقصود من أي منهم.
                                              </li>
                                              <br />
                                              <li>
                                                أوافق على تصوير ابني/ابنتي،  تصويري خلال مشاركته/مشاركتها في أنشطة المنتجع. أفهم أن هذه الصور ومقاطع الفيديو قد تُستخدم لأغراض ترويجية أو تسويقية من قبل المنتجع.
                                              </li>
                                              <br />
                                              <li>
                                                كما أوافق على تعويض وإخلاء مسؤولية الأطراف المعوضين أعلاه ودفع الأذى والضرر عنهم من أي خسارة أو مسؤولية أو ضرر أو تكاليف قد يتكبدونها مما ينشأ عن أو يتصل بالأنشطة وذلك في حال نتجت عن الإهمال أو الإهمال الكلي أو سوء السلوك المقصود من طرفي أو أحد ورثتي أو ممثليّ الشخصيين أو أقاربي.
                                              </li>
                                              <br />
                                              <li>
                                                إنني أتفهم وأوافق على أن اتفاق إخلاء المسؤولية هذا يغطي جميع وأي من الإحداث والفعاليات التي أشارك بها في أي نشاط أو أي من الأنشطة التي أشارك فيها لاحقاً في منتجع الفرسان أو في أي مكان آخر يتم تنظيم الأنشطة فيه من قبل منتجع الفرسان.
                                              </li>
                                              <br />
                                              <li>إنني أدرك بأنني أتحمل المسؤولية الكاملة عن كافة المعدات التي يتم تزويدي بها أو أقوم باستئجارها. كما أتفهم بشكل كامل بأنني أتحمل المسؤولية مالياً تجاه منتجع الفرسان عن أي خسارة أو ضرر في أي من المعدات التي أقوم باستئجارها أو يتم توفيرها لي. </li>
                                              <br />
                                              <li>وإضافة إلى ذلك، فإنني أتفهم بأنني أتحمل المسؤولية شخصياً عن أي من المعدات الشخصية التي قد أقوم باستخدامها، وأضمن بأن كافة معداتي الشخصية تتوافق مع لوائح السلامة القياسية المتبعة لدى منتجع الفرسان، وأي جهة مختصة أخرى من أي ناحية من النواحي.</li>
                                              <br />
                                              <li> هل تستطيع السباحة؟</li>
                                              <br />
                                              <li>
                                                نعم
                                                لا
                                                إذا أجبت بـ لا، يرجى العلم أنه يجب عليك الالتزام بتعليمات مشرف السباحة.
                                              </li>
                                            </ol>

                                            <p class="font_14 fw-med Aed-add-text mb_20">
                                              لقا قم بقساءة ن م م رين خاي ء المسيؤنليأ مي ه ا بطكل كامل ن
                                              رام ن اس ما ياص عليه األ كيييا نالطيييسنو، ن اس ن رامييي بييي
                                              اا قيييا راابل ع ال قينل األساسييأ مي اي ل الرنقيي عليب هي ا
                                              الردميا بم يا خسااري نان ي و ن خكساه، كما اس ن رام األاس
                                              القاانا له
                                            </p>

                                            <!--<p class="font_14 fw-med Aed-add-text mb_20">
        السبا أ خلباميأ لمماسسأ السيا ا المائيأ بقبنل ه ه النايقأ
        سادربس ا ردسف السبا أ
    </p>-->
                                          </div>
                                        </div>
                                    </div>
                            </td>
                        </tr>
                    </table>
                    <div class="register_detail_section mt_20">
                        <h5 *ngIf="registrationData.CustomerSignatureBase64"
                            class="font_18 fw-semi dis_customer_info_heading m-0">Signature</h5>
                        <div class="customer_signature_blk d-flex align-items-end">
                            <div class="regiter_uploded_doc pr_20" *ngIf="registrationData.CustomerSignatureBase64">
                                <img src="{{registrationData.CustomerSignatureBase64}}" class="sign_customer_img" />
                                <h2 class="font_16 fw-normal text_black m-0">Customer Signature</h2>
                            </div>
                            <div class="regiter_uploded_doc pl_20 pr_0" *ngIf="registrationData.ParentSignatureBase64">
                                <img src="{{registrationData.ParentSignatureBase64}}" class="sign_customer_img" />
                                <h2 class="font_16 fw-normal text_black m-0">Guardian Signature</h2>
                            </div>
                        </div>
                    </div>

                </div>
               
            </div>
        </div>
        </div>
    </td>
</tr>
    </table>
    <img src="assets/images_new/arrow-left.svg" alt="left-arrow" class="go_back_icon cursor_pointer" aria-label="Close"
        (click)="disclaimerClose()">
    <button class="dis_dwld_btn" (click)="convertToPdf()"><img src="assets/images_new/download.svg" alt="printer-icon"
            class="cursor_pointer"></button>

<ng-template #viewImage let-close="close">
    <div class="modal-body">
        <div class="d-flex align-items-center">
            <img src="assets/images_new/modal-xmark.svg" alt="left-arrow" class="cursor_pointer popup_close_icon"
                data-bs-dismiss="modal" aria-label="Close" (click)="Close()">          
        </div>
        <div class="">
            <span class="font_20 fw-semi d-flex justify-content-center mb_20">Preview</span>
            <img [src]="viewingIMG" alt="Image" class="event_preview_img">
        </div>
    </div>
</ng-template>
